/* eslint-disable arrow-body-style */
import { Box, Modal } from '@mui/material';
import DiplomaNewEditForm from '../../@dashboard/diploma/DiplomaNewEditForm';
import { Diploma } from 'src/@types/Diploma';

export const DiplomaModal = ({
  open,
  handleClose,
  isEdit,
  currentDiploma,
}: {
  open: boolean;
  // `saved` is true when closing after a successful create/edit.
  handleClose(saved?: boolean): void;
  isEdit: boolean;
  currentDiploma: Diploma | undefined;
}) => {
  return (
    <Modal
      open={open}
      onClose={() => handleClose()}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 760,
          maxHeight: '92vh',
          overflowY: 'auto',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: { xs: 2.5, sm: 4 },
          outline: 'none',
        }}
      >
        <DiplomaNewEditForm
          handleClose={handleClose}
          isEdit={isEdit}
          currentDiploma={currentDiploma}
        />
      </Box>
    </Modal>
  );
};
